import { Box, Divider, Flex, Icon, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaMapMarker } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ContractState } from "../../../../common/redux/reducers/contractReducer";
import { useOrganizationProfileUrls } from "../../../organizations/useOrganizationProfileUrls";
import { ProfileImageRounded } from "../../../sourcing-events/buyer/view-all/ProfileImageRounded";
import { requireCounterparty } from "../../typeguards";
import { getCounterpartyCountry, getCounterpartyName } from "../../view-all/ContractRow";

interface Props {
  data: ContractState["contract"];
}

export const Counterparty = ({ data }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const profileUrls = useOrganizationProfileUrls();

  const counterparty = requireCounterparty(data);
  const name = getCounterpartyName(counterparty);
  const country = getCounterpartyCountry(counterparty);

  const handleOrganizationClick = () => {
    if (counterparty.organization) {
      navigate(profileUrls.go(counterparty.organization.id));
    } else if (counterparty.organizationEntry) {
      navigate(profileUrls.goToEntry(counterparty.organizationEntry.id));
    }
  };

  return (
    <Box padding="15px" w="100%">
      <Text fontWeight={"bold"} fontSize="sm" color="smMuted">
        {t("Counterparty")}
      </Text>
      <Divider marginTop={"5px"} marginBottom={"5px"} />
      <Flex mt="13px" onClick={handleOrganizationClick} cursor="pointer" p="2">
        <Flex>
          <ProfileImageRounded name={name} width="30px" backgroundColor="blue.500" fontSize={"xs"} />
        </Flex>
        <Flex justifyContent={"center"} mt="-1px" ml="7px">
          <Text fontSize={"xl"} fontWeight="semibold">
            {name}
          </Text>
        </Flex>
      </Flex>
      <Flex mt="15px">
        <Icon as={FaMapMarker} ml="6px" w="15px" h="15px" color={"smMuted"} />
        <Text fontSize={"sm"} color="smMuted" ml="17px" mt="-3px">
          {country.name}
        </Text>
      </Flex>
    </Box>
  );
};
